import PasswordValidator from 'password-validator';
import { Buffer } from 'buffer';

// Email regex taken from: https://stackoverflow.com/a/46181
export const EMAIL_VALIDATION_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const passwordSchema = new PasswordValidator()
  .is()
  .min(8)
  .has()
  .uppercase()
  .has()
  .lowercase()
  .has()
  .digits()
  .has()
  .symbols();

export function isPasswordValid(password: string): boolean {
  const byteLength = Buffer.byteLength(password, 'utf8');

  return byteLength <= 72 && (passwordSchema.validate(password) as boolean);
}

export function isEmailValid(email: string): boolean {
  return EMAIL_VALIDATION_REGEX.test(email);
}
